export enum MediaType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Document = 'document',
}

export enum MediaOrigin {
  DASHBOARD = 'dashboard',
  CONTENT_TOOL = 'content-tool',
}

export type Media = {
  id: number
  src: string
  name: string
  type: MediaType
  origin: MediaOrigin
}

export type MediaId = Media['id']
